import { ApplicationUserDataService } from "../../core/applicationusers.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";
import { ApplicationUsers } from "./application-users.component";
import { EditApplicationUser } from "./application-user.edit.component";
import { ApplicationUser } from "./application-user.component";
import { RoleDataService } from "../../core/roles.dataservice";

/**
 * This state displays all Application Users
 */
export const applicationUsersState: Ng2StateDeclaration = {
    name: "app.settings.applicationusers",
    url: "/applicationusers",
    views: {
        "main-view@app": {
            component: ApplicationUsers
        }
    },
    resolve: {
        applicationUsers: ["applicationUserDataService", (applicationUserDataService: ApplicationUserDataService) => {
            return applicationUserDataService.getAll();
        }]
    }
};

/**
 * This state is for creating a new Application User
 */
export const newApplicationUserState: Ng2StateDeclaration = {
    name: "app.settings.applicationusers.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditApplicationUser
        }
    },
    resolve: {
        applicationUser: function () {
            return <Nema.Crew.Model.ApplicationUser>{
                Name: "",
                Mail: "",
                PermissionAdmin: false,
                PermissionRead: false,
                PermissionWrite: false,
                UserRoles: [],
                Active: true,
                RepositoryId: "",
                RepositoryPath: "",
                JwtToken: "",
                TennantId: -1,
                Password: ""
            };
        },
        roles: [RoleDataService.Id, (roleDataService: RoleDataService) => {
            return roleDataService.getAll();
        }],
        isNew: function () {
            return true;
        }
    }
};

/**
 * This state is for editing a Application User
 */
export const editApplicationUserState: Ng2StateDeclaration = {
    name: "app.settings.applicationusers.edit",
    url: "/edit/{id}",
    views: {
        "main-view@app": {
            component: EditApplicationUser
        }
    },
    resolve: {
        applicationUser: ["applicationUserDataService", "$stateParams", function (applicationUserDataService: ApplicationUserDataService, $stateParams) {
            return applicationUserDataService.get($stateParams.id);
        }],
        roles: [RoleDataService.Id, (roleDataService: RoleDataService) => {
            return roleDataService.getAll();
        }],
        isNew: function () {
            return false;
        }
    }
};

/**
 * Application User Details state
 */
export const applicationUserState: Ng2StateDeclaration = {
    name: "app.settings.applicationusers.detail",
    url: "/{id}",
    views: {
        "main-view@app": {
            component: ApplicationUser
        }
    },
    resolve: {
        applicationUser: ["applicationUserDataService", "$stateParams", function (applicationUserDataService: ApplicationUserDataService, $stateParams) {
            return applicationUserDataService.get($stateParams.id);
        }],
        roles: [RoleDataService.Id, (roleDataService: RoleDataService) => {
            return roleDataService.getAll();
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/applicationusers/application-users.states.ts